import type { CampaignTemplatesQueryVariables } from '~/api/graphql/queries/campaignTemplates.generated';
import type { IUseQueryCampaignsByTypeReturn } from './useQueryCampaignsByType';

import { CAMPAIGN_TYPE, CAMPAIGNS_QUERY_PAGE_SIZE } from '~/constants/campaign';
import { useQueryCampaignsByType } from './useQueryCampaignsByType';
import { useCampaignStore } from '~/modules/campaign';
import { useVariantStore } from '../modules';

export const campaignTemplatesQueryVariables: CampaignTemplatesQueryVariables = {
  first: CAMPAIGNS_QUERY_PAGE_SIZE,
  where: {
    type: CAMPAIGN_TYPE.TEMPLATE,
    hasVariants: true,
    deletedAtIsNil: true,
  },
};

export const useQueryCampaignTemplates = (): IUseQueryCampaignsByTypeReturn => {
  const isQueryCampaignTemplate = useCampaignStore((state) => state.isQueryCampaignTemplate);
  const setIsQueryCampaignTemplate = useCampaignStore((state) => state.setIsQueryCampaignTemplate);
  const setIsFetchedVariants = useVariantStore((state) => state.setIsFetchedVariants);

  return useQueryCampaignsByType({
    type: CAMPAIGN_TYPE.TEMPLATE,
    queryVariables: campaignTemplatesQueryVariables,
    isQueried: isQueryCampaignTemplate,
    setIsQueried: setIsQueryCampaignTemplate,
    getIsQueried: () => useCampaignStore.getState().isQueryCampaignTemplate,
    sentrySource: 'useQueryCampaignTemplates',
    onLoaded: () => setIsFetchedVariants(true),
  });
};
